import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import App from './App';
import AdminPage from './pages/Admin';
import LoginPage from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SupabaseConfig from './pages/SupabaseConfig';
import { trackPageView } from './lib/visitorTracking';
import './index.css';

// Page view tracker component
const PageViewTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view when location changes
    trackPageView().catch(error => {
      console.error('Failed to track page view:', error);
    });
  }, [location]);
  
  return null;
};

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <Router>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/config/supabase" element={<SupabaseConfig />} />
      </Routes>
    </Router>
  </StrictMode>
);